/* eslint-disable no-console */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const log = (enableLogs, ...args) => {
    if (enableLogs) {
        console.log(...args);
    }
};
